import { string } from 'prop-types';

export default {
    title: string.isRequired,
    summary: string.isRequired
};
